<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/orderList' }">订单</el-breadcrumb-item>
                <el-breadcrumb-item>订单{{type == '1' ? '编辑' : '新增',}}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submitDetailsData('ruleDetailsForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleDetailsForm" :label-position="labelPosition" class="details">
                        <el-form-item label="提交时间：" prop="submission_time" v-if="type == 1">
                            <el-input v-model="ruleForm.submission_time" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="收款时间：" prop="submission_time" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.money_received_time"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="发货时间：" prop="goods_delivery_time" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.goods_delivery_time"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="应收时间：" prop="money_receivable_time" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.money_receivable_time"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="发票时间：" prop="invoice_time" v-if="type == 1">
                            <el-input v-model="ruleForm.invoice_time" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="收货时间：" prop="goods_received_time" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.goods_received_time"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="名称：" prop="name">
                            <el-input v-model="ruleForm.name" size="mini" placeholder="请输入名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="供方：" prop="supplier_name">
                            <el-select
                                v-model="ruleForm.supplier_name"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="请输入供方搜索"
                                :remote-method="remoteMain"
                                :loading="mainLoading"
                                size="mini"
                                clearable
                                @change="mainChange"
                            >
                                <el-option v-for="item in mainOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="需方：" prop="demander_name">
                            <el-select
                                v-model="ruleForm.demander_name"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="请输入需方搜索"
                                :remote-method="demanderMain"
                                :loading="demanderLoading"
                                size="mini"
                                clearable
                                @change="demanderChange"
                            >
                                <el-option v-for="item in demanderOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="合作方：" prop="partner_name">
                            <el-select
                                v-model="ruleForm.partner_name"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="请输入合作方搜索"
                                :remote-method="remotePartner"
                                :loading="partnerLoading"
                                size="mini"
                                @change="partnerChange"
                                clearable
                            >
                                <el-option v-for="item in partnerOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="产品：" prop="product_name">
                            <el-select
                                v-model="ruleForm.product_name"
                                placeholder="请选择产品"
                                clearable
                                filterable
                                size="mini"
                                multiple
                                value-key="product_rid"
                                @focus="productFocus"
                                @change="productChange"
                            >
                                <el-option
                                    v-for="item in productOptions"
                                    :key="item.product_rid"
                                    :label="item.product_name"
                                    :value="item.product_rid"
                                >
                                </el-option>
                            </el-select>
                            <el-tooltip class="Tooltip" effect="dark" content="请先选择供方、需方、合作方" placement="top-start">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="授信天数：" prop="goods_received_time" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.agreed_credit_days"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="赊销天数：" prop="goods_received_time" v-if="type == 1">
                            <el-input v-model="ruleForm.credit_days" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="逾期天数：" prop="goods_received_time" v-if="type == 1">
                            <el-input v-model="ruleForm.overdue_days" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="综合状态：" prop="goods_received_time" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.integrated_status"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="发票总价：" prop="goods_received_time" v-if="type == 1">
                            <el-input v-model="ruleForm.invoice_price" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="总限额：" prop="goods_received_time" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.marginal_expense_quota"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="赊销额：" prop="goods_received_time" v-if="type == 1">
                            <el-input v-model="ruleForm.credit_amount" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="赊销积数：" prop="goods_received_time" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.credit_accumulation"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="应收额：" prop="goods_received_time" v-if="type == 1">
                            <el-input v-model="ruleForm.receivable" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                        </el-form-item>
                        <el-form-item label="应收积数：" prop="goods_received_time" v-if="type == 1">
                            <el-input
                                v-model="ruleForm.receivable_accumulation"
                                class="flex_item_text"
                                size="mini"
                                readonly="readonly"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="" prop="" v-if="type == 1"> </el-form-item>
                        <el-form-item label="创建人：" prop="created_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.created_by ? ruleForm.created_by : '' }} 
                            </div>
                        </el-form-item>
                        <el-form-item label="上次修改人：" prop="updated_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.updated_by ? ruleForm.updated_by : '' }}
                            </div>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="产品信息" name="2">
                    <el-form :label-position="labelPosition" v-for="(item, index) in productList" :key="index" class="details">
                        <el-form-item label="产品名称：">
                            <div class="read_only">{{ item.product_name }}</div>
                        </el-form-item>
                        <el-form-item label="产品数量：">
                            <el-input
                                size="mini"
                                v-model="item.quantity"
                                placeholder="请输入产品数量"
                                @change="quantityChange(item)"
                                type="number"
                                clearable
                            ></el-input>
                            <el-tooltip class="Tooltip" effect="dark" content="数量为必填项" placement="top-start">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
            <el-dialog
                :close-on-click-modal="false"
                title="产品版本已发生变更，是否要继续创建订单？"
                :visible.sync="dialogVisible"
                width="45%"
                :before-close="handleClose"
                v-dialogDrag
            >
                <el-radio v-model="radio" label="1">根据当前产品版本创建订单</el-radio>
                <el-radio v-model="radio" label="2">根据合作价格的产品版本创建订单</el-radio>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="cancelData">取 消</el-button>
                    <el-button type="primary" @click="oKData">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
export default {
    name: 'orderEdit',
    data() {
        return {
            radio: '',
            rid: '',
            title: '', //新增或编辑
            type: '', //1  编辑 2 新增
            activeNames: ['1', '2'],
            btnLoading: false,
            labelPosition: 'right',
            //基本信息内表单验证
            ruleForm: {
                name: '',
                supplier_name: '',
                demander_name: '',
                partner_name: '',
                product_name: [],
                supplier_rid: '',
                demander_rid: '',
                partner_rid: '',
                submission_time: '',
                money_received_time: '',
                agreed_credit_days: '',
                credit_days: '',
                overdue_days: '',
                integrated_status: '',
                invoice_price: '',
                marginal_expense_quota: '',
                credit_amount: '',
                credit_accumulation: '',
                receivable: '',
                receivable_accumulation: '',
                goods_delivery_time: '',
                money_receivable_time: '',
                invoice_time: '',
                goods_received_time: ''
            },
            rules: {
                name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                supplier_name: [{ required: true, message: '请输入供方', trigger: 'blur' }],
                demander_name: [{ required: true, message: '请输入需方', trigger: 'blur' }],
                partner_name: [{ required: true, message: '请输入合作方', trigger: 'blur' }],
                product_name: [{ required: true, message: '请选择产品', trigger: 'blur' }]
            },
            states: [],
            mainLoading: false,
            mainOptions: [],
            demanderLoading: false,
            demanderOptions: [],
            partnerLoading: false,
            partnerOptions: [], //合作方列表
            productOptions: [], //产品列表
            productList: [], //选中产品信息列表
            selectArr: [],
            check_product_version: '3',
            orderDetail: [],
            updateDetail: [],
            okPass: '',
            dialogVisible: false,
            btnTitle: ''
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.rid = this.$route.query.id;
    },
    mounted() {
        if (this.type == 1 || this.type == 5) {
            this.getDetails(); //获取详情
        } else {
            this.ruleForm = {};
        }
    },
    computed: {
        listSet() {
            return this.states.map((item) => {
                return { value: `${item.rid}`, label: `${item.name}` };
            });
        }
    },
    methods: {
        cancelData() {
            this.dialogVisible = false;
        },
        oKData() {
            this.check_product_version = this.radio;
            this.submitAddData();
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done();
                })
                .catch((_) => {});
        },
        //每个数值框变化赋值
        quantityChange(item) {
            var product_rid = item.product_rid;
            var quantity = item.quantity;
            for (let i = 0; i < this.updateDetail.length; i++) {
                if (product_rid === this.updateDetail[i].product_rid) {
                    this.updateDetail[i].quantity = quantity;
                }
            }
            if (this.type == 5) {
                for (let i = 0; i < this.orderDetail.length; i++) {
                    if (product_rid === this.orderDetail[i].product_rid) {
                        this.orderDetail[i].quantity = quantity;
                    }
                }
            }
        },
        //产品请求提示框
        productFocus() {
            if (!this.ruleForm.supplier_rid) {
                this.$message({
                    message: '请先选择供方',
                    type: 'warning'
                });
            } else if (!this.ruleForm.demander_rid) {
                this.$message({
                    message: '请先选择需方',
                    type: 'warning'
                });
            } else if (!this.ruleForm.partner_rid) {
                this.$message({
                    message: '请先选择合作方',
                    type: 'warning'
                });
            } else {
                this.getProduct(); //获取产品
            }
        },
        //产品改变联动框
        productChange(value) {
            if (!this.ruleForm.supplier_rid) {
                this.$message({
                    message: '请先选择供方',
                    type: 'warning'
                });
                this.ruleForm.product_name = [];
            } else if (!this.ruleForm.demander_rid) {
                this.$message({
                    message: '请先选择需方',
                    type: 'warning'
                });
                this.ruleForm.product_name = [];
            } else if (!this.ruleForm.partner_rid) {
                this.$message({
                    message: '请先选择合作方',
                    type: 'warning'
                });
                this.ruleForm.product_name = [];
            } else {
                if (this.selectArr.length > value.length) {
                    //跟去此方法来确定当前取消选中的是哪一项 然后去重
                    let arr = this.getArrDifference(this.selectArr, value);
                    for (let i = 0; i < this.productList.length; i++) {
                        if (arr[0] === this.productList[i].product_rid) {
                            this.productList.splice(i, 1);
                        }
                    }
                }
                this.selectArr = value;
                if (value.length > 0) {
                    let num = this.ruleForm.product_name.length - 1;
                    let product_rid = this.ruleForm.product_name[num];
                    //当前选中 去重
                    for (let i = 0; i < this.productList.length; i++) {
                        if (product_rid === this.productList[i].product_rid) {
                            this.productList.splice(i, 1);
                        }
                    }
                    //当前选中 去重
                    for (let i = 0; i < this.updateDetail.length; i++) {
                        if (product_rid === this.updateDetail[i].product_rid) {
                            this.updateDetail.splice(i, 1);
                        }
                    }
                    let params = {
                        supplier_rid: this.ruleForm.supplier_rid,
                        demander_rid: this.ruleForm.demander_rid,
                        partner_rid: this.ruleForm.partner_rid,
                        product_rid: product_rid
                    };
                    this.$api
                        .bestPrice(params)
                        .then((res) => {
                            if (res.code == 0) {
                                var data = res.data;
                                if (Object.keys(data).length !== 0) {
                                    data.quantity = '';
                                    this.productList.push(data);
                                }
                            }
                        })
                        .catch((error) => {
                            
                        });
                } else {
                    this.productList = [];
                    this.updateDetail = [];
                    this.orderDetail = [];
                }
            }
        },
        //获取当前点击取消的当前项 因为elementUI 框架bug
        getArrDifference(arr1, arr2) {
            return arr1.concat(arr2).filter(function (v, i, arr) {
                return arr.indexOf(v) === arr.lastIndexOf(v);
            });
        },
        //去重方法
        unique(arr, val) {
            const res = new Map();
            return arr.filter((item) => !res.has(item[val]) && res.set(item[val], 1));
        },
        //获取产品
        getProduct() {
            let params = {
                supplier_rid: this.ruleForm.supplier_rid,
                demander_rid: this.ruleForm.demander_rid,
                partner_rid: this.ruleForm.partner_rid
            };
            this.$api
                .partnerPriceProducts(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.productOptions = res.data;
                    }
                })
                .catch((error) => {
                    
                });
        },
        //合作方搜索
        remotePartner(query) {
            if (query !== '') {
                this.partnerLoading = true;
                let params = {
                    name: query
                };
                this.$api
                    .searchPartners(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.states = res.data;
                            setTimeout(() => {
                                this.partnerLoading = false;
                                this.partnerOptions = this.listSet.filter((item) => {
                                    return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                                });
                            }, 200);
                        } else {
                            this.partnerOptions = [];
                        }
                    })
                    .catch((error) => {
                        
                    });
            } else {
                this.partnerLoading = false;
                this.partnerOptions = [];
            }
        },
        // /合作方联动框改变
        partnerChange(value) {
            this.ruleForm.partner_rid = value;
        },
        //需方远程搜索方法
        demanderMain(query) {
            if (query !== '') {
                this.demanderLoading = true;
                let params = {
                    name: query
                };
                this.$api
                    .searchAccounts(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.states = res.data;
                            setTimeout(() => {
                                this.demanderLoading = false;
                                this.demanderOptions = this.listSet.filter((item) => {
                                    return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                                });
                            }, 200);
                        } else {
                            this.demanderOptions = [];
                        }
                    })
                    .catch((error) => {
                        
                    });
            } else {
                this.demanderLoading = false;
                this.demanderOptions = [];
            }
        },
        //主联系人联动框改变
        demanderChange(value) {
            this.ruleForm.demander_rid = value;
        },
        //供方远程搜索方法
        remoteMain(query) {
            if (query !== '') {
                this.mainLoading = true;
                let params = {
                    name: query
                };
                this.$api
                    .searchAccounts(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.states = res.data;
                            setTimeout(() => {
                                this.mainLoading = false;
                                this.mainOptions = this.listSet.filter((item) => {
                                    return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                                });
                            }, 200);
                        } else {
                            this.mainOptions = [];
                        }
                    })
                    .catch((error) => {
                        
                    });
            } else {
                this.mainLoading = false;
                this.mainOptions = [];
            }
        },
        //主联系人联动框改变
        mainChange(value) {
            this.ruleForm.supplier_rid = value;
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/orderList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .orderDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.ruleForm.name = res.data.name;
                        this.ruleForm.supplier_name = res.data.supplier_name;
                        this.ruleForm.demander_name = res.data.demander_name;
                        this.ruleForm.partner_name = res.data.partner_name;
                        this.ruleForm.created_at = res.data.created_at;
                        this.ruleForm.created_by = res.data.created_by;
                        this.ruleForm.updated_at = res.data.updated_at;
                        this.ruleForm.updated_by = res.data.updated_by;
                        this.ruleForm.supplier_rid = res.data.supplier_rid;
                        this.ruleForm.demander_rid = res.data.demander_rid;
                        this.ruleForm.partner_rid = res.data.partner_rid;
                        this.ruleForm.submission_time = res.data.submission_time;
                        this.ruleForm.money_received_time = res.data.money_received_time;
                        this.ruleForm.agreed_credit_days = res.data.agreed_credit_days;
                        this.ruleForm.credit_days = res.data.credit_days;
                        this.ruleForm.overdue_days = res.data.overdue_days;
                        this.ruleForm.integrated_status = res.data.integrated_status;
                        this.ruleForm.invoice_price = res.data.invoice_price;
                        this.ruleForm.marginal_expense_quota = res.data.marginal_expense_quota;
                        this.ruleForm.credit_amount = res.data.credit_amount;
                        this.ruleForm.credit_accumulation = res.data.credit_accumulation;
                        this.ruleForm.receivable = res.data.receivable;
                        this.ruleForm.receivable_accumulation = res.data.receivable_accumulation;
                        this.ruleForm.goods_delivery_time = res.data.goods_delivery_time;
                        this.ruleForm.money_receivable_time = res.data.money_receivable_time;
                        this.ruleForm.invoice_time = res.data.invoice_time;
                        this.ruleForm.goods_received_time = res.data.goods_received_time;
                        if (res.data.lines.length > 0) {
                            for (var i = 0; i < res.data.lines.length; i++) {
                                this.ruleForm.product_name.push(res.data.lines[i].product_rid);
                            }
                        }
                        this.getProduct(); //获取产品
                        this.productList = res.data.details;
                        this.productList.forEach((value, index) => {
                            // 明细类型为普通（底价或限额）
                            if (value.type == 10 || value.type == 11) {
                                this.updateDetail.push({
                                    quantity: value.quantity,
                                    order_detail_rid: value.rid,
                                    product_rid: value.product_rid
                                });
                            }
                        });
                    }
                })
                .catch((error) => {
                    
                });
        },
        //提交新增/编辑修改
        submitDetailsData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.type == 1) {
                        for (let i = 0; i < this.productList.length; i++) {
                            if (!this.productList[i].approval_status) {
                                this.updateDetail.forEach((value, index) => {
                                    delete value.product_rid;
                                    if (value.quantity) {
                                        this.updateDetail.push({
                                            quantity: value.quantity,
                                            order_detail_rid: value.order_detail_rid
                                        });
                                        this.okPass = 2;
                                    } else {
                                        this.$message({
                                            type: 'info',
                                            message: '数量为必填项'
                                        });
                                        this.okPass = 1;
                                    }
                                });
                            } else {
                                this.productList.forEach((value, index) => {
                                    if (value.quantity) {
                                        this.orderDetail.push({
                                            product_rid: value.product_rid,
                                            partner_price_rid: value.rid,
                                            quantity: value.quantity
                                        });
                                        this.okPass = 2;
                                    } else {
                                        this.$message({
                                            type: 'info',
                                            message: '数量为必填项'
                                        });
                                        this.okPass = 1;
                                    }
                                });
                            }
                        }
                        this.updateDetail.forEach((value, index) => {
                            //删除id 因提交参数无  product_rid是前端用来筛选
                            delete value.product_rid;
                            this.updateDetail.push({
                                quantity: value.quantity,
                                order_detail_rid: value.order_detail_rid
                            });
                        });
                        this.updateDetail = this.unique(this.updateDetail, 'order_detail_rid');
                        this.orderDetail = this.unique(this.orderDetail, 'product_rid');
                        if (this.okPass == 2) {
                            this.submitEditData(); //修改
                        }
                    } else {
                        this.productList.forEach((value, index) => {
                            if (value.quantity) {
                                if (this.type == 5) {
                                    this.orderDetail.push({
                                        product_rid: value.product_rid,
                                        partner_price_rid: value.partner_price_rid,
                                        quantity: value.quantity
                                    });
                                } else {
                                    this.orderDetail.push({
                                        product_rid: value.product_rid,
                                        partner_price_rid: value.rid,
                                        quantity: value.quantity
                                    });
                                }
                                this.okPass = 2;
                            } else {
                                this.$message({
                                    type: 'info',
                                    message: '数量为必填项'
                                });
                                this.okPass = 1;
                            }
                        });
                        this.orderDetail = this.unique(this.orderDetail, 'product_rid');
                        if (this.okPass == 2) {
                            this.submitAddData(); //新增
                        }
                    }
                } else {
                    return false;
                }
            });
        },
        //提交修改
        submitEditData() {
            this.btnLoading = true;
            let params = {
                supplier_rid: this.ruleForm.supplier_rid,
                demander_rid: this.ruleForm.demander_rid,
                partner_rid: this.ruleForm.partner_rid,
                name: this.ruleForm.name,
                check_product_version: '2',
                insert_detail: this.orderDetail,
                update_detail: this.updateDetail,
                rid: this.rid
            };
            this.$api
                .orderUpdate(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                    
                });
        },
        //提交新增
        submitAddData() {
            this.btnLoading = true;
            let params = {
                supplier_rid: this.ruleForm.supplier_rid,
                demander_rid: this.ruleForm.demander_rid,
                partner_rid: this.ruleForm.partner_rid,
                name: this.ruleForm.name,
                check_product_version: this.check_product_version,
                order_detail: this.orderDetail
            };
            this.$api
                .orderInsert(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '新增成功！',
                            type: 'success'
                        });
                        this.cancel();
                    } else if (res.code == 1034) {
                        this.dialogVisible = true;
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                    
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>